import Vue from 'vue'
import moment from 'moment'
import {
  Button,
  Card,
  Row,
  Col,
  Input,
  Form,
  Icon,
  Layout,
  Divider,
  Avatar,
  Tag,
  Affix,
  Popover,
  Drawer,
  Tabs,
  Radio,
  DatePicker,
  InputNumber,
  Spin,
  Steps,
  Table,
  Menu,
  Tooltip,
  List,
  Rate,
  message,
  notification
} from 'ant-design-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import api from './api/api.js'
import logger from './utils/log.js'
import msg from './utils/msg'
import * as permissions from './config/permissions.json'

Vue.use(Button)
Vue.use(Card)
Vue.use(Row)
Vue.use(Col)
Vue.use(Form)
Vue.use(Spin)
Vue.use(InputNumber)
Vue.use(Steps)
Vue.use(Input)
Vue.use(Icon)
Vue.use(Layout)
Vue.use(Divider)
Vue.use(Avatar)
Vue.use(Tag)
Vue.use(Affix)
Vue.use(Popover)
Vue.use(Drawer)
Vue.use(Tabs)
Vue.use(Radio)
Vue.use(DatePicker)
Vue.use(Table)
Vue.use(Menu)
Vue.use(Tooltip)
Vue.use(List)
Vue.use(Rate)
Vue.config.productionTip = false
//Global var======start======
Vue.prototype.$moment = moment
Vue.prototype.$api = api
Vue.prototype.$message = message
Vue.prototype.$notification=notification
Vue.prototype.$logger = logger
Vue.prototype.$permissions = permissions.default
Vue.prototype.$error_handler = function(vue,err) {
  if(err.code == "020003"){
    let token = vue.$store.getters.refresh;
    console.log("refresh token")
    vue.$api.refresh({token:token})
    .then(data =>{
      let resp = data.data;
      if (resp.error) {
        vue.$router.push({
          path: "/login"
        });
      }else{
        vue.$store.dispatch("updateToken", resp.result.token);
        vue.$store.dispatch("updateInfo");
        vue.$router.go({path: vue.$router.currentRoute.path, force: true})
      }
    })
    .catch(err => {
      vue.$router.push({
        path: "/login"
      });
    })
  }else{
    vue.$notification.error({
      message: "エラー:" + err.code,
      description: err.description
    });
  }
}
//Global var======end======



router.beforeEach((to, from, next) => { // [1]
  let token = store.getters.token
  // logger.d('main', 'beforeEach', {
  //   to: to,
  //   from: from,
  //   token: token
  // })

  if (to.name !== 'login' && !token && to.name !== 'test') {
    // return router.push({
    //   path: '/login'
    // })
  }
  next()
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
